import { jsx as C } from "react/jsx-runtime";
import { SvgIcon as e } from "../SvgIcon.js";
const d = (o) => /* @__PURE__ */ C(e, { ...o, children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9866 9.99914C19.9866 15.5189 15.5119 19.9935 9.99218 19.9935C4.47244 19.9935 -0.00219727 15.5189 -0.00219727 9.99914C-0.00219727 4.4794 4.47244 0.00476074 9.99218 0.00476074C15.5119 0.00476074 19.9866 4.4794 19.9866 9.99914ZM5.00232 9.99451C5.00232 9.30981 5.56555 8.74658 6.25025 8.74658C6.93495 8.74658 7.49818 9.30981 7.49818 9.99451C7.49818 10.6792 6.93495 11.2424 6.25025 11.2424C5.56555 11.2424 5.00232 10.6792 5.00232 9.99451ZM12.5009 9.99451C12.5009 9.30981 13.0642 8.74658 13.7489 8.74658C14.4336 8.74658 14.9968 9.30981 14.9968 9.99451C14.9968 10.6792 14.4336 11.2424 13.7489 11.2424C13.0642 11.2424 12.5009 10.6792 12.5009 9.99451ZM8.74611 9.99451C8.74611 9.30981 9.30933 8.74658 9.99404 8.74658C10.6898 8.74658 11.242 9.30981 11.242 9.99451C11.242 10.6792 10.6787 11.2424 9.99404 11.2424C9.30933 11.2424 8.74611 10.6792 8.74611 9.99451Z"
  }
) });
export {
  d as Ellipsis2
};
//# sourceMappingURL=Ellipsis2.js.map
